import TeaserModel from 'models/properties/teaserModel';
import {Collection} from 'backbone';

export default Collection.extend({
    model: TeaserModel,
    comparator: 'position',
    createTeaser(teaser) {
        // move all teaser positions back by 1
        this.models.forEach(function(model) {
            model.set('position', model.get('position') + 1);
        });
        // insert new teaser at beginning of teaserList
        this.unshift(new TeaserModel(teaser));

        return this;
    },
    toJSONWithCids() {
        return this.models.map(model => Object.assign({cid: model.cid}, model.toTemplateJSON()));
    },
});
